import type { StreamId } from '@vlabs/api/artemy/model';
import { useParams } from 'react-router-dom';

export function useStreamIdFromLocation(): StreamId {
  const { streamId } = useParams<{ streamId: StreamId }>();

  return streamId;
}
